import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    signUpUser as signUpUserAction,
    clearAuthNotification as clearAuthNotificationAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
    trackLoginInsteadClick as trackLoginInsteadAction,
} from '../../actions/auth';

import SignupPage from './SignupPage';

const _mapStateToProps = ({ authentication, form }) => ({
    form,
    email: authentication.email,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    shouldIncludeEmailConfirmation:
        authentication.shouldIncludeEmailConfirmation,
    disableRecaptcha3: authentication.disableRecaptcha3,
});

const _mapDispatchToProps = {
    onSignUpUser: signUpUserAction,
    clearAuthNotification: clearAuthNotificationAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    onLoginInsteadClick: trackLoginInsteadAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignupPage),
);
